(() => {
  if (window.babaPressEditorReady) return;
  window.babaPressEditorReady = true;
  const carouselCleanups = new Map();
  let navObserver;
  function updateCounts() {
    const collections = [...document.querySelectorAll('[data-baba-collection]')];
    const total = collections.reduce((sum, collection) => sum + collection.querySelectorAll('.baba-entry').length, 0);
    const summary = document.querySelector('[data-baba-total]');
    if (summary) summary.textContent = `${total} records across ${collections.length === 6 ? 'six' : collections.length} collections`;
    document.querySelectorAll('.baba-jump a').forEach(link => {
      const section = document.getElementById(link.hash.slice(1));
      link.hidden = !section;
      if (!section) return;
      link.querySelector('small').textContent = section.querySelectorAll('.baba-entry').length;
      if (section.dataset.babaLabel) link.querySelector('span').textContent = section.dataset.babaLabel;
    });
    const nav = document.querySelector('.baba-jump');
    navObserver?.disconnect();
    if (nav) {
      const measure = () => document.body.style.setProperty('--baba-jump-height', Math.ceil(nav.getBoundingClientRect().height) + 'px');
      if ('ResizeObserver' in window) { navObserver = new ResizeObserver(measure); navObserver.observe(nav); }
      measure();
    }
  }
  function initCarousel() {
    const rail = document.getElementById('baba-logo-rail');
    if (!rail || carouselCleanups.has(rail)) return;
    const controls = rail.closest('.baba-logo-carousel').querySelector('.baba-logo-controls');
    const originals = [...rail.children];
    if (!originals.length) return;
    const copies = originals.map(item => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true'); copy.dataset.babaClone = 'true';
      copy.removeAttribute('data-shopify-editor-block');
      copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
      rail.append(copy); return copy;
    });
    const controller = new AbortController(); const options = {signal:controller.signal};
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const toggle = controls.querySelector('[data-logo-pause]');
    let width=0, paused=reduced.matches, hovered=false, focused=false, frame=null, last=null, position=0;
    const playing = () => !paused && !hovered && !focused && !document.hidden && width>0 && rail.isConnected;
    const tick = time => {
      frame=null;
      if (!playing()) return;
      if(last!==null) { position=(position+Math.min(time-last,64)*32/1000)%width; rail.scrollLeft=position; }
      last=time; frame=requestAnimationFrame(tick);
    };
    const sync=()=>{ if(frame!==null) cancelAnimationFrame(frame); frame=null;last=null;position=rail.scrollLeft;toggle.textContent=paused?'Play':'Pause';toggle.setAttribute('aria-label',paused?'Start automatic logo scrolling':'Pause automatic logo scrolling');if(playing())frame=requestAnimationFrame(tick); };
    const measure=()=>{width=copies[0].offsetLeft-originals[0].offsetLeft;controls.hidden=width<=0;sync();};
    const move=direction=>{paused=true;sync();if(!width)return;rail.scrollLeft%=width;const step=Math.min(rail.clientWidth*.8,width*.8);if(direction<0&&rail.scrollLeft<step)rail.scrollLeft+=width;rail.scrollBy({left:direction*step,behavior:reduced.matches?'auto':'smooth'});};
    toggle.addEventListener('click',()=>{paused=!paused;sync();},options);
    controls.querySelectorAll('[data-logo-direction]').forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.logoDirection)),options));
    rail.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch'){hovered=true;sync();}},options);
    rail.addEventListener('pointerleave',()=>{hovered=false;sync();},options);
    rail.addEventListener('focusin',()=>{focused=true;sync();},options);
    rail.addEventListener('focusout',e=>{focused=rail.contains(e.relatedTarget);sync();},options);
    rail.addEventListener('pointerdown',()=>{paused=true;sync();},{...options,passive:true});
    rail.addEventListener('wheel',e=>{if(e.deltaX||e.shiftKey){paused=true;sync();}},{...options,passive:true});
    rail.addEventListener('keydown',e=>{if(e.target===rail&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},options);
    reduced.addEventListener('change',e=>{paused=e.matches;sync();},options);
    document.addEventListener('visibilitychange',sync,options);
    window.addEventListener('resize',measure,{...options,passive:true});
    window.addEventListener('pagehide',()=>{if(frame!==null)cancelAnimationFrame(frame);},options);
    window.addEventListener('pageshow',measure,options);
    const observer='ResizeObserver' in window?new ResizeObserver(measure):null;observer?.observe(rail);
    carouselCleanups.set(rail,()=>{controller.abort();observer?.disconnect();if(frame!==null)cancelAnimationFrame(frame);copies.forEach(copy=>copy.remove());carouselCleanups.delete(rail);});
    measure();
  }
  const init=()=>{for(const [rail,cleanup] of carouselCleanups)if(!rail.isConnected)cleanup();updateCounts();initCarousel();};
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('.baba-jump a[href^="#"]'); if(!link)return;
    const target=document.getElementById(link.hash.slice(1));if(!target)return;
    event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});target.tabIndex=-1;target.focus({preventScroll:true});
  });
  ['shopify:section:load','shopify:section:reorder'].forEach(name=>document.addEventListener(name,init));
  document.addEventListener('shopify:section:unload',event=>{for(const [rail,cleanup]of carouselCleanups)if(event.target.contains(rail))cleanup();requestAnimationFrame(updateCounts);});
  document.addEventListener('shopify:block:select',event=>{const logo=event.target.closest?.('.baba-logo-item');if(logo){const rail=logo.closest('.baba-logo-rail');rail?.dispatchEvent(new Event('pointerdown'));logo.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
